import { useContext } from 'react'
import { contractsPropertyContext } from '../../../pages/chaloupka/contracts'
import { PropertySearchForm } from './PropertySearchForm'

export const ContractsPropertySearch = () => {
  const { updateFilter, filter } = useContext(contractsPropertyContext)

  return (
    <PropertySearchForm
      filter={filter}
      onSubmit={updateFilter}
      listType='contracted'
    />
  )
}
